var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGravarAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 25.1579C23.7529 25.1579 25.5579 23.4653 25.5579 21.3684L25.5714 13.7895C25.5714 11.6926 23.7529 10 21.5 10C19.2471 10 17.4286 11.6926 17.4286 13.7895V21.3684C17.4286 23.4653 19.2471 25.1579 21.5 25.1579ZM28.6929 21.3684C28.6929 25.1579 25.2457 27.8105 21.5 27.8105C17.7543 27.8105 14.3071 25.1579 14.3071 21.3684H12C12 25.6884 15.6914 29.2379 20.1429 29.8568V34H22.8571V29.8568C27.3086 29.2505 31 25.6884 31 21.3684H28.6929Z",
    fill: "#A6446A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGravarAudio);
export default __webpack_public_path__ + "static/media/ic_gravar_audio.fcfaedef1688e7bf41e1e36386ee3bf1.svg";
export { ForwardRef as ReactComponent };